import { render, staticRenderFns } from "./lesson-data.vue?vue&type=template&id=a5ad472e&scoped=true"
import script from "./lesson-data.vue?vue&type=script&lang=js"
export * from "./lesson-data.vue?vue&type=script&lang=js"
import style0 from "./lesson-data.vue?vue&type=style&index=0&id=a5ad472e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ad472e",
  null
  
)

export default component.exports